import { selfDeterminationDefaultCategory } from '@appvantageasia/core-module-config-consts';
import type { TFunction } from 'i18next';
import type { PsychologicalResult } from '../../model';
import formatScoreOutOf from '../formatters';
import { selfDeterminationHeight } from '.';
import type { AssessmentResultItemDataFragment } from '@/gql/graphql';

const parseSelfDetermination = (
    t: TFunction,
    items: AssessmentResultItemDataFragment[]
): PsychologicalResult | null => {
    const item = items.find(i => i.result.__typename === 'SelfDeterminationResult');
    if (!item || item.result.__typename !== 'SelfDeterminationResult') {
        return null;
    }

    const { moduleInstance } = item;
    const selfDeterminationResult = item.result;

    if (!moduleInstance?.moduleDefinitionIdentifier) {
        return null;
    }

    const categories =
        selfDeterminationResult?.categoryAverages?.filter(
            c => c.category !== selfDeterminationDefaultCategory.Overall
        ) || [];
    if (categories.length === 0) {
        return null;
    }

    const radarData = categories.map(c => ({
        axis: c.category,
        individual: Number(c.averageScore.toFixed(1)),
    }));
    const maxDomain = Math.max(1, ...categories.map(c => c.maximumPossibleScore ?? 0));

    return {
        moduleDefinitionIdentifier: moduleInstance.moduleDefinitionIdentifier,
        name: moduleInstance.name ?? '',
        description: moduleInstance.description ?? '',
        radarGroups: [
            {
                key: 'self-determination',
                scoreCards: categories.map(c => ({
                    label: c.category,
                    value: formatScoreOutOf(t, c.averageScore, c.maximumPossibleScore, 1),
                })),
                charts: [
                    {
                        data: radarData,
                        maxDomain,
                        height: selfDeterminationHeight,
                        variant: 'bare',
                        footer: t('traineeReports:labels.individual'),
                    },
                ],
            },
        ],
    };
};

export default parseSelfDetermination;
